import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import {
    AuthenticationService,
    EspaceClientService,
    User,
} from '@kv-common-components/kx-services';
import { ContextDossier } from '@kv-common-components/kv-common-components';
import { AssuranceHelperService } from '@shared/services/assurance-helper.service';
import { RouteEnum } from '@shared/services/route-enum';
import { RouterHelperService } from '@shared/services/router-helper.service';

@Component({
    templateUrl: './chargement.component.html',
})
export class ChargementComponent implements OnInit {
    goBackToEspaceClientModal = false;
    currentEspaceClient: any;
    currentUser: User;
    currentProject: any;
    contextDossier: ContextDossier = null;
    currentStepId: string;
    isLoading: boolean;

    constructor(
        private espaceCltService: EspaceClientService,
        private authService: AuthenticationService,
        private router: Router,
        private logger: NGXLogger,
        private routerHelperService: RouterHelperService
    ) {}

    ngOnInit(): void {
        this.isLoading = true;
        this.currentUser = this.authService.currentUserValue;
        this.espaceCltService
            .getEspaceClient(this.currentUser.idPersonne)
            .subscribe((response) => {
                this.currentEspaceClient = response;
                this.currentProject =
                    this.currentEspaceClient.listeProjetsCredits.find(
                        (projet) =>
                            projet.idProjetCredit === this.currentUser.idDossier
                    );
                this.contextDossier = new ContextDossier();
                this.contextDossier.emprunteur =
                    this.currentProject.listeEmprunteurs.find(
                        (itv) => itv.idPersonne === this.currentUser.idPersonne
                    );
                this.currentStepId = 'signature_dad';
                if (
                    this.routerHelperService.isStatutSignaturePropo() ||
                    this.routerHelperService.isStatutFinalisationAfterPropoSignature()
                ) {
                    this.currentStepId = 'signature_propo';
                }
                this.isLoading = false;
            });
        window.scrollTo(0, 0);
    }

    navigateToEspaceClient() {
        this.router.navigateByUrl(RouteEnum.dashboard);
    }

    navigateToNextStep() {
        if (
            AssuranceHelperService.isCodeAiaStatutDAForUploadMedicalDocument(
                this.contextDossier.emprunteur.assurance.statutDA
            )
        ) {
            this.logger.debug('navigate to differed decision introduction');
            this.router.navigateByUrl(RouteEnum.differedDecisionIntroduction);
        } else if (
            AssuranceHelperService.qsEnCoursEtude.codeAia ===
            this.contextDossier.emprunteur.assurance.statutDA ||
            AssuranceHelperService.dossierCompletEnCoursEtude.codeAia ===
            this.contextDossier.emprunteur.assurance.statutDA
        ) {
            this.logger.debug('navigate to en-attente');
            this.router.navigateByUrl(RouteEnum.documentWaiting);
        } else if (
            AssuranceHelperService.isCodeAiaStatutDAForSignaturePropo(
                this.contextDossier.emprunteur.assurance.statutDA
            )
        ) {
            this.logger.debug('navigate to signature');
            this.router.navigateByUrl(RouteEnum.signature);
        } else {
            this.logger.debug('navigate to finalisation');
            this.router.navigateByUrl(RouteEnum.finalisation);
        }
    }
}
